module.exports = __webpack_public_path__ + "static/media/一种实名制意外保险自助销售设备.1b98dafa.png";